import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SUPER_ADMIN_EMAIL = process.env.REACT_APP_SUPER_ADMIN_EMAIL;

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  
  const isAdmin = 
    user?.isAdmin === true ||
    user?.role === 'admin' ||
    (SUPER_ADMIN_EMAIL && user?.email === SUPER_ADMIN_EMAIL);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  if (!isAdmin) {
    console.log('Admin access denied for:', user?.email);
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
};

export default AdminRoute;